import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { detectCountryLanguage } from '../lib/geolocation';

import en from './locales/en.json';
import hi from './locales/hi.json';
import es from './locales/es.json';
import id from './locales/id.json';
import pt from './locales/pt.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import no from './locales/no.json';
import sv from './locales/sv.json';
import da from './locales/da.json';
import fi from './locales/fi.json';

const resources = {
  en: { translation: en },
  hi: { translation: hi },
  es: { translation: es },
  id: { translation: id },
  pt: { translation: pt },
  de: { translation: de },
  fr: { translation: fr },
  no: { translation: no },
  sv: { translation: sv },
  da: { translation: da },
  fi: { translation: fi },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

// Function to detect and set language based on country
const detectAndSetLanguage = async (): Promise<void> => {
  try {
    // Check if user has manually selected a language (stored in localStorage)
    const storedLanguage = localStorage.getItem('i18nextLng');
    if (storedLanguage && storedLanguage !== 'cimode') {
      // User has manually selected a language, respect their choice
      return;
    }

    // Try to detect language based on country
    const countryLanguage = await detectCountryLanguage();
    
    if (countryLanguage && countryLanguage !== i18n.language) {
      // Set the detected language
      await i18n.changeLanguage(countryLanguage);
      console.log(`Language automatically set to ${countryLanguage} based on detected country`);
    }
  } catch (error) {
    console.warn('Country-based language detection failed:', error);
    // Fall back to browser language detection (already handled by i18next)
  }
};

// Initialize country-based language detection after i18n is ready
i18n.on('initialized', () => {
  detectAndSetLanguage();
});

export default i18n;